import { render, staticRenderFns } from "./email_show_panel.vue?vue&type=template&id=6ba67dde&"
import script from "./email_show_panel.vue?vue&type=script&lang=js&"
export * from "./email_show_panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba67dde')) {
      api.createRecord('6ba67dde', component.options)
    } else {
      api.reload('6ba67dde', component.options)
    }
    module.hot.accept("./email_show_panel.vue?vue&type=template&id=6ba67dde&", function () {
      api.rerender('6ba67dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/mailboxer/email_show_panel.vue"
export default component.exports